


























import { Component, Vue, Prop } from 'vue-property-decorator';

// eslint-disable-next-line no-unused-vars
import { StatementType } from '@/types/services';
// eslint-disable-next-line no-unused-vars
import { IAdditionalStatements } from '@/utils/types';
import { RouteName } from '@/router';
import { statementTypeToIsWithdrawn } from '@/app.config';

import ConfirmationModalView from '@/components/base/ConfirmationModalView.vue';

@Component({
  components: {
    ConfirmationModalView,
  },
})
export default class AltWithdrawnButton extends Vue {
  @Prop({ default: ()=>{} }) parentStatement!: any;

  private showDialogWithdrawn: boolean = false;
  private showWithdrawnButton: boolean = false;
  private withdrawnStatements: IAdditionalStatements[] = [];
  private statementType!: StatementType;
  private statementId!: string;
  

  mounted() {
    this.statementId = this.$route.params.id;
    this.statementType = this.parentStatement.statementType;

    if (
      this.parentStatement?.additionalStatements &&
      this.parentStatement.additionalStatements.length > 0
    ) {
      this.withdrawnStatements = this.parentStatement.additionalStatements.filter(
        (item: IAdditionalStatements) => {
          return item.type === 'WITHDRAWAL';
        }
      );
    }

    this.showWithdrawnButton = this.isWithdrawnButton();
  }

  isWithdrawnButton() {
    // получаем конфиги, условие отображение кнопки
    if (!statementTypeToIsWithdrawn[this.statementType]) {
      return false;
    }

    // показывать кнопку при статусах основного заявления
    const condition_1 = [
      'SENT_TO_EIS',
      'PRIMARY_VALIDATION',
      'IN_QUEUE',
      'DISTRIBUTED',
      'IN_PROGRESS',
      'AWAITING_PAYMENT',
      'SUSPENDED_AWAITING_DOCUMENTS',
      'SUSPENDED_DOCUMENTS_PROVIDED',
    ].includes(this.parentStatement.statusCode);

    // доп. заявления на отказ, либо не должно быть, либо статус REJECTED_ALT, DRAFT
    const condition_2 =
      !this.withdrawnStatements ||
      this.withdrawnStatements.length === 0 ||
      this.withdrawnStatements.some((item: any) =>
        ['REJECTED_ALT', 'DRAFT', 'VALIDATION_ERROR_ALT'].includes(item.status)
      );

    // основное заявление еще не должно быть оплачено
    const condition_3 = !this.parentStatement.wasPaid;

    return condition_1 && condition_2 && condition_3;
  }

  onStatementRollBack() {
    this.showDialogWithdrawn = false;
    this.$router.push({
      name: RouteName.ALTERNATIVE_SERVICE_REFUSAL,
      params: { parentStatementId: this.statementId },
    });
  }
}
